<template>
  <div class="writings-item-box" v-loading="dataloading">
    <template v-if="dataloading == false">
      <div class="item-header">
        <div class="item-title">{{ blockItem.name }}</div>
        <div v-show="showFooter == false" class="more" @click="handleMore">更多</div>
      </div>
      <div v-if="blockItems.length > 0" class="article-list">
        <div v-for="item in blockItems"
          :key="item.id" 
          class="article-item"
          @click="handleBlockItem(item)">
          <span class="dot">●</span><span class="article-title">{{ item.title }}</span>
        </div>
      </div>    
      <div v-else class="article-list">
        <el-empty :image-size="50"></el-empty>
      </div>
      <div class="item-footer" v-show="showFooter == true">      
        <div class="more" @click="handleMore">更多</div>
      </div>
    </template>
  </div>
</template>

<script>
  import { getBlockItemList } from "@/api/content"; 
  export default {
    components: { },
    props: {
      blockItem: {
        type: Object,
        default: ()=>({})
      },

      hasFooter: null,
    },
    data() {
        return {
          blockItems: [],
          showFooter: false,
          dataloading: true,
        };
      },
    methods: {
      getDataList(){
        this.dataloading = true;
          getBlockItemList(0, this.blockItem.alias, 3).then(result => {
            this.dataloading = false;
            if(result.code == 0){
                if(result.data != null){
                  this.blockItems = result.data;                      
                }                                 
            }else{
                this.blockItems = [];
            }
              //console.log(result.data.list);            
          }).catch((err)=>{
            this.dataloading = false;
          });
        },
      
        handleMore(){          
          this.$router.push(
            {
              path: '/wencui',
              query:{
                tab: this.blockItem.alias,
              }
            }
          );
        },

        handleBlockItem(item){   
          let routeData = this.$router.resolve({
              path: '/article',
              query:{
                id: item.articleId,
              }
            });
          window.open(routeData.href, '_blank');
        },
    },
    created() {  
      if(this.hasFooter == null || this.hasFooter == undefined){
        this.showFooter = false;
      }else{
        this.showFooter = this.hasFooter;
      }      
      
      this.getDataList();
    },
    mounted() {}
  };
</script>

<style scoped>
.writings-item-box{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  padding: 20px;
  flex-grow: 1;
  background: #014289;  
  box-sizing: border-box;
}

.item-header{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px 0px;
  align-self: stretch;
}
.item-title{
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  letter-spacing: 0em;
  color: #FFFFFF;
}

.more{
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  color: #FFFFFF;
  cursor: pointer;
}
.more:hover{
  opacity: 0.8;
}

.article-list{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  padding: 0px 0px 0px 16px;
  align-self: stretch;
}

.article-item{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 0px;
  /*gap: 10px;*/
  align-self: stretch;
  box-sizing: border-box;
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.1);
  cursor: pointer;
  -webkit-transition: color,0.5s;
  transition: color,0.5s;
}
.dot
{
  width: 6px;
  color: #FFFFFF;
  line-height: 24px;
  margin-right: 10px;
}
.article-title
{  
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  color: #FFFFFF;
}
.article-item:hover{
  background: rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.1);
}
.item-footer{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0 0 0;
}
@media screen and (max-width: 750px){
  .writings-item-box{
    padding: 10px;    
  }
  .item-header{
    display: none;
  }
  .article-list{
    padding: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/writingsblock/writingsitem.vue